import React from "react";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../assets/Icons";
import ReimbursementAccountDetails from "../../../containers/Accounts/ReimbursementAccount/ReimbursementAccountDetails";
import LargePopupRedirect from "../CommonPopups/CommonLargePopupRedirect";

function ReimbursementAccountDetailsPopup({
  closeBeneAccountDetailModal,
  reimburse_account_id,
  type,
  showCategory,
  TxnHistoryAccountName,
}) {
  const navigate = useNavigate();

  return (
    <div onClick={(e) => e.stopPropagation()}>
      <LargePopupRedirect
        headerTitle="Reimbursement account details"
        headerFontWeight="semibold"
        smallpopupsubtext={
          "Opening in full view will leave this page and exit the current flow."
        }
        headerFontColor="text-primary"
        smallPopupHeader={"Open in full view?"}
        headertextSize="font-md"
        isfullViewrequired={true}
        fullviewbtnText="Open in full view"
        fullviewbtnType="button"
        fullviewhandleFunction={() => {
          closeBeneAccountDetailModal();
          navigate(
            `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${reimburse_account_id}`,
          );
        }}
        fullviewisDisabled={false}
        fullviewenabledTextColor="var(--text-primary)"
        fullviewenabledBgColor="var(--primary-nav)"
        fullviewhoverOption="white"
        fullviewicon={ICONS?.REDIRECT}
        fullviewdisabledBgColor="var(--text-disabled)"
        closeiconbtnType="button"
        closeiconhandleFunction={closeBeneAccountDetailModal}
        closeiconisDisabled={false}
        closeiconenabledBgColor="var(--primary-nav)"
        closeicondisabledBgColor="var(--text-disabled)"
        closeiconhoverOption="white"
        closeicon={ICONS?.CLOSE}
        isbottomSectionneed={false}
        bottomHeaderTextNeed={false}
        isscrollRequired={true}
      >
        <ReimbursementAccountDetails
          bene_account_id={reimburse_account_id}
          type={type}
          closeBeneAccountDetailModal={closeBeneAccountDetailModal}
          showCategory={showCategory}
          TxnHistoryAccountName={TxnHistoryAccountName}
        />
      </LargePopupRedirect>
    </div>
  );
}

export default ReimbursementAccountDetailsPopup;
